import { App } from 'vue'
import { registerI18nPlugin } from '@/services/i18n'
import { registerSmartBanner } from '@/plugins/smart-banner'

export function registerPlugins(app: App) {
  registerI18nPlugin(app)
  registerSmartBanner()
  // TODO: registerGTMPlugin(app)
}
